import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import ClipLoader from "react-spinners/ClipLoader";

const AdminShield = ({ allowedRoles, children }) => {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <ClipLoader color="#5cd400" loading={true} size={50} />
        <div className="mt-3 text-muted fs-5">Loading...</div>
      </div>
    );
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/xl-login" replace />;
  }

  return children;
};

export default AdminShield;
